import React from "react";
import "./footer.css";
const footer = () => {
  return (
    <div className="footer">
      <footer>
        <div className="data">
          <big>©</big> Pokedex App - 2023 All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default footer;
